'use client';

import { useCallback, useEffect } from 'react';

import { SECONDARY_FLOATING_BUTTON_THEME } from '@/constants/vars.constants';
import {
  useFloatingCTA,
  useSetFormItem,
} from '@/hooks/floating-cta.hook';
import { getLeadTypeForSpecial } from '@/services/specials/specials.service';
import { SpecialDetails } from '@/services/SpecialsService.service';
import { ConfigData } from '@/types/config/config.types';
import { NewCarData } from '@/types/new-cars/new-cars.types';
import { VehicleType } from '@/types/used-cars/used-cars.types';

interface Props {
  specialDetails: SpecialDetails;
  newCarDetails?: NewCarData;
  config?: ConfigData;
  mustUsePromotionsForm?: boolean;
  showWhatsApp?: boolean;
}

const PromotionsDetailsClient = ({
  specialDetails,
  newCarDetails,
  config: _config,
  mustUsePromotionsForm = false,
  showWhatsApp = false,
}: Props) => {
  const setFormItem = useSetFormItem();

  const {
    setSecondaryFloatingButton,
    setWhatsAppButton,
    setIsCTAShown,
    setPrimaryButtonAction,
    openWhatsAppForm,
  } = useFloatingCTA();

  const handleEnquiryOpen = useCallback(() => {
  }, []);

  useEffect(() => {
    setPrimaryButtonAction({
      onClick: handleEnquiryOpen,
      openForm: !mustUsePromotionsForm,
    });

    setIsCTAShown(true);

    return () => {
      setPrimaryButtonAction(null);
    };
  }, [
    mustUsePromotionsForm,
    handleEnquiryOpen,
    setIsCTAShown,
    setPrimaryButtonAction,
  ]);

  useEffect(() => {
    const leadType = getLeadTypeForSpecial(specialDetails);

    setFormItem({
      type: 'special',
      special: specialDetails,
      leadType,
    });

    if (
      specialDetails?.vehicle_type === VehicleType.New &&
      newCarDetails?.slug
    ) {
      setSecondaryFloatingButton({
        text: `View ${newCarDetails.main_title}`,
        url: `/new-cars/${newCarDetails.slug}`,
        display: 'all',
        colors: {
          ...SECONDARY_FLOATING_BUTTON_THEME,
        },
      });
    } else {
      setSecondaryFloatingButton(null);
    }

    if (showWhatsApp) {
      setWhatsAppButton({
        text: 'WhatsApp',
        display: 'all',
        onClick: openWhatsAppForm,
      });
    } else {
      setWhatsAppButton(null);
    }

    return () => {
      setFormItem(undefined);
      setSecondaryFloatingButton(null);
      setWhatsAppButton(null);
    };
  }, [
    specialDetails,
    newCarDetails,
    showWhatsApp,
    setFormItem,
    setSecondaryFloatingButton,
    setWhatsAppButton,
    openWhatsAppForm,
  ]);

  return null;
};

export default PromotionsDetailsClient;